import { Stack } from '@mui/material';
import { MessageBox } from 'components/MessageBox';
import React, { useMemo } from 'react';
import { useStoreState } from 'state/hooks/store.state.hook';

export interface IMissingOffersBlockProps {
  hasNoOffers: boolean;
  t: any;
}

export const MissingOffersBlock: React.FC<IMissingOffersBlockProps> = ({
  hasNoOffers,
  t,
}) => {
  const { storeTheme } = useStoreState();

  const { bundleBorderColor, noOffersTitleText, noOffersMessageText } =
    useMemo(() => {
      if (!storeTheme)
        return {
          bundleBorderColor: {
            colorOne: '#fff69d',
            colorTwo: '#e4981d',
            gradientDirection: 'to right',
          },
          noOffersTitleText: 'Lack of Special Offers.',
          noOffersMessageText:
            'Sorry, but there are no any special offers for you. Please try again later.',
        };

      return {
        bundleBorderColor: storeTheme.storeScreen.bundleBorderColor,
        noOffersTitleText:
          storeTheme.storeScreen.noOffersTitleText?.trim() ||
          (t ? t?.('shop.noOffersTitle') : 'No Offers Available'),
        noOffersMessageText:
          storeTheme.storeScreen.noOffersMessageText?.trim() ||
          (t
            ? t?.('shop.noOffersMessage')
            : 'No offers are available at the moment. Try again soon!'),
      };
    }, [storeTheme?.storeScreen, t]);

  if (!hasNoOffers) return <></>;

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      width="100%"
      className="no_offers_box"
      padding={'2vh'}
    >
      <MessageBox
        title={noOffersTitleText}
        text={noOffersMessageText}
        fontFamily={storeTheme!.general.font}
        borderColor={bundleBorderColor.colorOne}
        logo={storeTheme!.general.logo}
      />
    </Stack>
  );
};
